import FieldImage from "@Resources/game/backgrounds/4.jpg";
import useGlobalContext from "@hooks/common/general/use-global-context";
import useI18n from "@i18n";
import { Box, styled, useTheme } from "@mui/material";

const Version = styled(Box)(({ theme }) => ({
  color: theme.palette.dsBase.v200,
  width: "100%",
  textAlign: "right",
  margin: theme.spacing(1, 1, 0, 0),
  position: "absolute",
  bottom: theme.spacing(1),
  right: theme.spacing(1),
}));

interface IStaticBackground {}

const StaticBackground = ({}: IStaticBackground) => {
  const { i18n } = useI18n();
  const { globalState } = useGlobalContext();
  const theme = useTheme();
  const isAuth = globalState.user.authenticated;

  const getBackgroundStyles = () => {
    return isAuth
      ? {
          backgroundColor: theme.palette.dsBase.v100,
        }
      : {
          "::before": {
            position: `absolute`,
            inset: 0,
            content: '" "',
            background: `url(${FieldImage});`,
            filter: "brightness(40%) blur(3px) sepia(10%)",
            transform: "scale(1.6)",
            backgroundPosition: "center",
          },
        };
  };

  return (
    <Box
      id="BACKGROUND"
      sx={{
        height: "100vh",
        width: "100vw",
        position: "fixed",
        zIndex: -10,
        ...getBackgroundStyles(),
      }}
    >
      {globalState.app.bridgeInitialized ? <Version id={"version_id"}>{`${i18n("version")} ${globalState.app.clientVersion}`}</Version> : null}
    </Box>
  );
};

export default StaticBackground;
